export const createInitialValues = () => ({
  houses: [],
  relatedRoomIds: new Set(),
  relatedRoomsForRender: [],
  excludedRoomIds: [],
});
